import { Grid, Typography } from "@mui/material";

const Interests = () => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant='h4' sx={{mb: 0, color: '#378dab'}}>
                    Research Interests
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <ul>
                    <li>Security Aspects in Mobile Cyber-Physical Systems</li>
                    <li>Mobile Cloud Computing</li>
                    <li>Cybersecurity</li>
                    <li>Digital Forensics</li>
                </ul>
            </Grid>
            <Grid item xs={12}>
                <Typography variant='h4' sx={{mt: 1, mb: 0, color: '#378dab'}}>
                    Other Interests
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <ul>
                    <li>Playing Music <Typography variant='span' fontStyle={"italic"}>(I'm a multi-instrumentalist)</Typography></li>
                    <li>Walking</li>
                    <li>Roadtrips</li>
                </ul>
            </Grid>
        </Grid>
    )
};

export default Interests;